import { useGetImprovementProposal } from "@/api/console/improvement-proposals/useGetImprovementProposal";
import AdminContentContainer from "@/components/AdminContentContainer";
import AdminNavbar from "@/components/AdminNavbar/AdminNavbar";
import BottomBar from "@/components/BottomBar";
import Card from "@/components/Card";
import LoadingScreen from "@/components/Loading";
import {
  ImprovementProposal,
  improvementProposalSchema,
} from "@/schema/improvement-proposal/ImprovementProposal";
import ButtonGroup from "@/src/console/(auth)/(check-assessments)/check-submissions/[id]/proposal/_components/ButtonGroup";
import CollapsibleSubcategory from "@/src/console/(auth)/(check-assessments)/check-submissions/[id]/proposal/_components/CollapsibleSubCategory";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

function ImprovementProposalPage() {
  const { t } = useTranslation();
  const { id = "" } = useParams();

  const breadcrumbs = [
    {
      name: t("check-submissions"),
      href: "/console/check-submissions",
    },
    {
      name: t("proposal"),
      href: `/console/check-submissions/${id}/proposal`,
    },
  ];

  const { data, isLoading } = useGetImprovementProposal(id, {
    revalidateOnFocus: false,
    revalidateIfStale: false,
    revalidateOnMount: true,
    revalidateOnReconnect: false,
  });

  const methods = useForm<ImprovementProposal>({
    resolver: zodResolver(improvementProposalSchema),
    values: data?.data,
  });

  const { fields } = useFieldArray({
    control: methods.control,
    name: "main_category_results",
    keyName: "key",
  });

  if (!data || isLoading) return <LoadingScreen />;

  return (
    <FormProvider {...methods}>
      <AdminNavbar breadcrumbs={breadcrumbs} />
      <AdminContentContainer
        bottomBar={
          <BottomBar backLink="/console/check-submissions">
            <ButtonGroup id={id} />
          </BottomBar>
        }
      >
        <div className="p-6 pt-8 flex flex-col gap-2 bg-white shadow border-y">
          <p className="text-2xl font-bold">{t("improvement-proposal")}</p>
          <p className=" text-cool-gray-700 text-sm font-normal">
            {t("write-message-for-improment-proposal")}
          </p>
        </div>
        <div className=" mx-6 my-8 flex flex-col space-y-8">
          <Card className="overflow-hidden">
            {fields.map((field, index) => (
              <CollapsibleSubcategory key={field.key} index={index} />
            ))}
          </Card>
        </div>
      </AdminContentContainer>
    </FormProvider>
  );
}

export default ImprovementProposalPage;
